import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
const badgeVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)("tw-inline-flex tw-items-center tw-rounded-md tw-border tw-text-xs tw-font-medium tw-transition-colors focus:tw-outline-none focus:tw-outline-none focus:tw-ring-ring focus:tw-ring-offset-2", {
    variants: {
        variant: {
            default: "tw-border-primary-medium tw-bg-primary-light tw-text-primary hover:tw-text-primary/80 hover:tw-border-primary-medium/80",
            secondary: "tw-border-transparent tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80 hover:tw-text-secondary-foreground/80",
            neutral: "tw-border-neutral-300 tw-bg-neutral-100 tw-text-neutral-700 hover:tw-text-neutral-600 hover:tw-border-neutral-200",
            destructive: "tw-border-transparent tw-bg-destructive tw-text-destructive-foreground tw-shadow hover:tw-bg-destructive/80",
            outline: "tw-text-neutral-600 hover:tw-text-neutral-500",
            info: "tw-border-info-medium tw-bg-info-light tw-text-info-dark hover:tw-text-info-dark/80 hover:tw-border-info-medium/80",
            success: "tw-border-success-medium tw-bg-success-light tw-text-success-dark hover:tw-text-success-dark/80 hover:tw-border-success-medium/80",
            warning: "tw-border-warning-medium tw-bg-warning-light tw-text-warning-dark hover:tw-text-warning-dark/80 hover:tw-border-warning-medium/80",
            error: "tw-border-error-medium tw-bg-error-light tw-text-error-dark hover:tw-text-error-dark/80 hover:tw-border-error-medium/80"
        },
        size: {
            default: "tw-px-2.5 tw-py-0.5",
            sm: "tw-px-2.5 tw-py-0.25"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});
function Badge({ className, variant, size, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(badgeVariants({
            variant,
            size
        }), className),
        ...props
    });
}
export { Badge, badgeVariants };

//# sourceMappingURL=badge.mjs.map